import React from 'react'
import Select, { components } from 'react-select';
import { AiFillCaretDown } from 'react-icons/ai'


const selectStyles = {
    control: (base) => ({
        ...base,
        border: "none",
        borderBottom: '1px solid #2085f8',
        borderRadius: "0",
        padding: "0",
        minHeight: "20px",
        fontSize: "0.85rem",
        color: "#007697",
        boxShadow: '0 !important',
        "&:hover": {
            border: "none",
            borderBottom: '1px solid #2085f8',
        },
    }),
    option: (styles, { isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "rgba(0,0,0,0.1)" : isSelected ? "rgba(0,0,0,0.1)" : null,
            color: "#33333",
            fontSize: "0.85rem",
            paddingTop : '0.5rem',
            paddingBottom : '0.5rem'
        };
    },
    valueContainer: (base) => ({
        ...base,
        padding: '0.5rem 0',
    }),
    menuList: (base) => ({
        ...base,
        padding: 0,
        backgroundColor : '#fff',
        marginTop: 0,
        maxHeight: '11.5rem'
    }),
    dropdownIndicator: (styles) => ({ ...styles, padding: "0 0.5rem" }),
};

const CaretDownIcon = () => {
    return <AiFillCaretDown color="#2085f8" />;
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <CaretDownIcon />
        </components.DropdownIndicator>
    );
};


const CustomSelect = ({options,onChange,defaultValue,value}) => {
    return (
        <Select
            options={options}
            onChange={onChange}
            isClearable={false}
            isSearchable={false}
            classNamePrefix="custom-select"
            styles={selectStyles}
            value={value}
            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
            defaultValue={defaultValue}
        />
    )
}

export default CustomSelect